
export default {
  name: 'CheckoutHeaderStepperTopBelt',
  data () {
    return {
      steps: [{
        id: 1,
        name: 'Cart',
        path: 'index',
      }, {
        id: 2,
        name: 'Your data',
        path: 'index-step2',
      }, {
        id: 3,
        name: 'Summary',
        path: 'index-step3',
      }],
    }
  },

  methods: {
    getComponentByStep (step) {
      return this.$cart.isCartReadOnly()
        ? 'span'
        : step < this.$cart.getCurrentStep() ? 'NuxtLink' : 'span'
    },
  },
}
